import { responseHandlerInterceptor } from "../appApi/interceptors/response-handler.interceptor";
import { sendErrorMessage, sendSuccessMessage } from "../appApi/apiNotifyHandler";
export class MttUserClient {
    init(client, accessTokenProvider) {
        this.client = client;
        this.accessTokenProvider = accessTokenProvider;
        return this;
    }
    addResponseHandlerInterceptor() {
        responseHandlerInterceptor(this.client, (status, method, message) => sendSuccessMessage(status, method, message), (status, message) => sendErrorMessage(status, message));
        return this;
    }
}
const mttUserClient = new MttUserClient();
export default mttUserClient;
